import React from 'react'
import "./FabButton.css"

const FabButton = ({onClick}) => {

  return (
    <div className="fab-button-container">
    <button
      onClick={onClick}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 11V1"
          stroke="#4C3CA6"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M1 6H11"
          stroke="#4C3CA6"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
  )
}

export default FabButton